import { AxiosError } from 'axios';
import { FC } from 'react';
import { H2 } from '../../../../common/Headings/Headings.styles';
import { TableRowWrapper } from '../../../../common/SideBySideTableLayout/SideBySideTableLayout.styles';
import Button from '../../../../components/Button/Button';
import { Variant } from '../../../../components/Button/Button.types';
import Table from '../../../../components/Table/Table';
import { showToast } from '../../../../components/Toast/Toast';
import { genericErrorShowToastOptions } from '../../../../utils/useGenericErrorMessage/useGenericErrorMessage';
import { Buttons, StyledReviewChanges, StyledTableWrapper } from './ReviewChanges.styles';
import { ReviewChangesProps } from './ReviewChanges.types';

const ReviewChanges: FC<ReviewChangesProps> = ({ selectedOptionRecipes, setStep, mutate, isLoading }) => {
  const copyOptionRecipesRequestBody: number[] = selectedOptionRecipes.map((recipe) => recipe.specNo);

  const handleSave = () => {
    mutate(copyOptionRecipesRequestBody, {
      onSuccess: () => {
        setStep(2);
        showToast({ label: 'Option recipes were copied successfully.', id: 'copyOptionRecipesSuccess' });
      },
      onError: (error) => {
        if ((error as AxiosError).message === 'apiGatewayTimeout') return;
        showToast({
          ...genericErrorShowToastOptions,
          id: 'copyOptionRecipesError',
          label: 'Error copying option recipes.',
        });
      },
    });
  };

  return (
    <StyledReviewChanges>
      <H2>Review your changes</H2>
      <TableRowWrapper>
        <StyledTableWrapper>
          <Table
            rowData={selectedOptionRecipes}
            headerButtons={[{ label: 'Edit', variant: Variant.Text, onClick: () => setStep(0) }]}
            showHeader
            headerTitle='Copy Option Recipe Target'
            floatingFiltersHeight={0}
            returnedRecords={selectedOptionRecipes.length}
            columnDefs={[
              { minWidth: 220, flex: 1, field: 'specNo', headerName: 'Copy From' },
              { minWidth: 320, flex: 1, field: 'description', headerName: 'Description', resizable: false },
            ]}
            height={'100%'}
          />
        </StyledTableWrapper>
      </TableRowWrapper>
      <Buttons>
        <Button label='Back' variant={Variant.Secondary} onClick={() => setStep(0)} />
        <Button label='Save' onClick={handleSave} isLoading={isLoading} />
      </Buttons>
    </StyledReviewChanges>
  );
};

export default ReviewChanges;
